import {
  FILTER_TYPE_TO_LABEL,
  FILTER_TYPES,
  type FilterType,
} from '@/client/services/contentFilter'
import {
  MODERATION_FLAG_CATEGORIES,
  MODERATION_FLAG_CATEGORY_TO_LABEL,
  MODERATION_FLAG_VIOLATION_TYPE_TO_LABEL,
  MODERATION_FLAG_VIOLATION_TYPES,
  type ModerationFlagCategory,
  type ModerationFlagViolationType,
} from '@/client/services/moderation'

import type { FormInputType } from '@/components/UI/Form/types'

export default function getContentFilterFormInputs({
  category,
  filter,
  description,
  filterType,
  violationType,
}: {
  category?: ModerationFlagCategory | null
  filter?: string | null
  description?: string | null
  filterType: FilterType | null
  violationType?: ModerationFlagViolationType | null
}): FormInputType[] {
  return [
    filter == null
      ? {
          type: 'textarea',
          label: 'Filters',
          sublabel: 'Place each filter on a new line.',
          name: 'filter',
          size: 6,
          required: true,
        }
      : {
          type: 'text',
          label: 'Filter',
          name: 'filter',
          size: 6,
          required: true,
          initialValue: filter,
        },
    {
      type: 'select',
      label: 'Filter Type',
      name: 'filter_type',
      size: 6,
      required: true,
      options: FILTER_TYPES.map(filterTypeItem => ({
        value: filterTypeItem,
        label: FILTER_TYPE_TO_LABEL[filterTypeItem],
      })),
      initialValue: filterType,
    },
    {
      type: 'select',
      label: 'Category',
      name: 'category',
      size: 6,
      required: true,
      options: MODERATION_FLAG_CATEGORIES.map(categoryItem => ({
        value: categoryItem,
        label: MODERATION_FLAG_CATEGORY_TO_LABEL[categoryItem],
      })),
      initialValue: category,
    },
    {
      type: 'select',
      label: 'Violation Type',
      name: 'violation_type',
      size: 6,
      required: true,
      options: MODERATION_FLAG_VIOLATION_TYPES.map(violationTypeItem => ({
        value: violationTypeItem,
        label: MODERATION_FLAG_VIOLATION_TYPE_TO_LABEL[violationTypeItem],
      })),
      initialValue: violationType,
    },
    {
      type: 'text',
      label: 'Description',
      name: 'description',
      size: 6,
      required: false,
      initialValue: description,
    },
  ]
}
